module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_vm._v("General Techniques")]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("Making the braids or knotting is just the first stage in the process when making a piece of jewellery or an accessory and you then need to finish the piece in an attractive, neat and professional way. These general techniques can be used or adapted for many of the projects in the book. For specific finishing techniques for plaiting and Kumihimo braiding see "), _c('span', {
    attrs: {
      "href": "#/c11#Finishing-Techniques-for-Braiding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finishing Techniques for Braiding")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("ADDING A JUMP RING")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Jump rings are one of the most useful jewellery findings. Usually round, they can also be oval – a shape with more stability as the elongated ring tends to remain in one position.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1",
    attrs: {
      "id": "s1"
    }
  }, [_vm._v("1 Hold the jump ring with two pairs of flat-nose pliers either side of the join; tilt one pair towards you and the other away from you. Reverse the process to close the ring again.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_0622_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("2 To tension the jump ring so that the ends butt together, use pliers to push the ends slightly so that they overlap on one side and then the other. Pull back and the ends will spring together.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_0626_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("3 You can temper (harden) jump rings by opening and closing ring a few times (see "), _c('a', {
    attrs: {
      "href": "#/#s1"
    }
  }, [_vm._v("step 1")]), _vm._v("). Don’t overdo it or the ring will snap.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_0623_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD",
    attrs: {
      "id": "MAKING-A-PLAIN-LOOP"
    }
  }, [_vm._v("MAKING A PLAIN LOOP")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Use a headpin no thinner than 0.6mm (24 swg) wire to make this style of loop so that it is strong enough to keep its round shape when it is in use.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("1 Pick up the beads required onto the headpin and trim the tail to about 7–12mm ("), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("–"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in) – the length depends on the thickness of the wire and the size of the loop required – and bend it over at 90 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_1470_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("2 Hold the tip of the wire with round-nose pliers and rotate the pliers to bend the wire part-way around the tip of the jaws; the distance from the tip of the pliers determines the size of the loop.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_1468_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("3 Reposition the pliers by flipping your wrist, then continue to rotate the wire around until the tip touches the wire again and the loop is upright and central, like a lollipop.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_1469_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Making a bead link")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("Make a plain loop on one end of the wire, or start with an eyepin. Add the beads, then follow Making a Plain Loop to make a loop at the other end.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Image_1447_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("MAKING A WRAPPED LOOP")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("You can use a thinner wire for this loop as the wire wrapping makes it more secure. Use longer headpins for this technique – you’ll need at least 3cm (1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("in) of wire above the last bead.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("1 String the beads on the headpin and use snipe-nose pliers to bend the wire at a right angle above the last bead leaving a small gap for the wrapping.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/HeadPinWrapLoop_1_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("2 Hold the wire close to the bead with round-nose pliers, then wrap the tail all the way round to form a loop. Bring the wire right round so that it is at right angles to the wire threaded through the beads.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/HeadPinWrapLoop_2_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("3 Hold the loop securely in flat-nose pliers and wind the tail around the stem covering the gap between the bead and the loop. You can use another pair of pliers to wind the tail, then trim neatly using flush wire cutters.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/HeadPinWrapLoop_3_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("JOINING A WRAPPED LOOP TO A SOLID RING")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("If you are attaching the wrapped loop to chain, a solid ring or another wrapped loop, use this technique.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("1 Form the loop following Making a Wrapped Loop, steps 1 and 2, stopping before you wrap the tail. Feed the tail into the chain link or solid ring so that the loop is sitting where it should be.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/wrappedloopp17_1_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("2 Use snipe-nose pliers to hold the loop securely, then wind the tail around the gap above the bead using another pair of pliers to give you more purchase if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/wrappedloopp17_2_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS2"
  }, [_vm._v("3 Trim the tail close to the wrapped wire. Use the very tip of the wire cutters, flat side towards the wrapping, to get the neatest result.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/wrappedloopp17_3_fmt.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b741ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c02.vue
// module id = 69
// module chunks = 0